module.exports = __webpack_public_path__ + "img/341.a5714e12.png";